module.exports = __webpack_public_path__ + "img/supplier-003.47533456.png";